import { orderBy } from 'lodash';
import { parse } from 'date-fns';

import { DATE_FORMATS } from 'utils/date-helpers';
import { getLocationName } from 'utils/display-helpers';

export const sortUsers = (
  userList = [],
  sortByField,
  sortFieldType,
  sortOrder,
) => {
  if (!sortByField) return userList;

  if (!userList || userList.length === 0) {
    return [];
  }

  const createSortArray = (array, fieldName) => {
    const ret = [];

    array.forEach((user) => {
      const tmp = {
        ...user,
        ...{
          sortResult:
            sortFieldType === 'date' || fieldName === 'extension'
              ? user[fieldName]
              : user[fieldName]?.toLowerCase(),
        },
      };

      ret.push(tmp);
    });

    return ret;
  };

  const sortingList = createSortArray(userList, sortByField);
  const consistentSort = orderBy(sortingList, ['nextiva_uuid']);
  let sortedArray = orderBy(consistentSort, ['sortResult'], [sortOrder]);

  // move null values of sorted field
  // to the bottom of the list
  const nullValues = sortedArray.filter((u) => !u[sortByField]);
  const values = sortedArray.filter((u) => u[sortByField]);
  sortedArray = [...values, ...nullValues];

  return sortedArray;
};

export const formatPhoneNum = (num) => {
  if (!num) return '';
  const number = num.split('-')[1];
  const first = number.slice(0, 3);
  const second = number.slice(3, 6);
  const third = number.slice(6);

  return `(${first}) ${second}-${third}`;
};

/**
 * Format the users objects to render the user list tables.
 *
 * @param {Array} users List of users
 * @param {Array} locations List of Location Options
 */
export const formatUsers = (users, locations, authV3Enabled, corpAcctNbr) => {
  return users.map((m) => {
    const user = { ...m };

    user.checked = false;
    user.status = authV3Enabled
      ? user.profiles.find(
          (prof) => prof.corporateAccountNumber === corpAcctNbr,
        )?.active
      : user.status === 'Active';
    user.statusDisplay = user.status ? 'Active' : 'InActive';
    user.createdDate = user.createdDate
      ? parse(
          user.createdDate.substring(0, 8),
          DATE_FORMATS.DEFAULT,
          new Date(),
        )
      : '';
    user.updatedDate = user.updatedDate
      ? parse(
          user.updatedDate.substring(0, 8),
          DATE_FORMATS.DEFAULT,
          new Date(),
        )
      : '';
    user.deactivatedDate = user.deactivatedDate
      ? parse(
          user.deactivatedDate.substring(0, 8),
          DATE_FORMATS.DEFAULT,
          new Date(),
        )
      : '';

    user.roleDisplay = user.roles?.map((role) => role.name).join(', ');
    user.teamDisplay = user.team?.map((team) => team.name).join(', ');
    user.locationDisplay =
      user.profiles.length > 0
        ? getLocationName(locations, user.profiles[0].locationId)
        : '';
    user.phoneNumber = formatPhoneNum(
      user?.profiles[0]?.phone_number ?? user?.profiles[0]?.phoneNumber,
    );

    user.extension =
      user?.profiles[0]?.extension || user?.profiles[0]?.voiceExtension || '';

    return user;
  });
};
